import { CheckOutlined, CloseOutlined, DeleteOutlined, DownloadOutlined, EditOutlined, LoadingOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Form, Input, Popconfirm, Select, Spin, Table, Tooltip, Typography, DatePicker } from "antd";
import { AddOffCycleData, DeleteOffCycleData, FetchAllOffCycleCodesAndHeaders, FetchAllOffCycleData, FetchFileNumberData, FetchHistoricOffCycleData, UpdateOffCycleData, UploadOffCycleData } from "../../Repository/OffCycleRepository";
import { useEffect, useState } from "react";
import { ErrorMessage, GetDefaultDate, InfoMessage, ReplaceUnderscoreWithSpace, StringValidations, SuccessMessage, WarnMessage } from "../../Utils/Utils";
import Upload from "antd/es/upload/Upload";
import './OffCycleComponent.css';
import { UserName } from "../../Repository/BaseRepository";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import dayjs from 'dayjs';


const OffCycleGrid = () => {

    //State Variables
    const [DefaultHeaders, setDefaultHeaders] = useState([]);
    const [EAD_Codes, setEAD_Codes] = useState([]);
    const [SelectedHeaders, setSelectedHeaders] = useState([]);
    const [SearchGridValue, setSearchGridValue] = useState([]);
    const [FileList, setFileList] = useState([]);
    const [editingKey, setEditingKey] = useState("");
    const [oldData, setOldData] = useState([]);
    const [NewRecordKey, setNewRecordKey] = useState(null);
    const [OffCycleUploadFlag, setOffCycleUploadFlag] = useState(false);
    const [SkeletonFlag, setSkeletonFlag] = useState(false);
    const [AddRecordSearch, setAddRecordSearch] = useState("");


    const [PayDate, setPayDate] = useState("");
    const [ProcessedDate, setProcessedDate] = useState(GetDefaultDate());
    const [GridDataSource, setGridDataSource] = useState([]);



    const isEditing = (record) => record.OffCycleId === editingKey;
    const [form] = Form.useForm();

    const BuildSelectedHeaders = async (TempDefaultHeaders) => (
        TempDefaultHeaders.map((item, index) => ({
            key: item,
            value: item,
            children: ReplaceUnderscoreWithSpace(item)
        }))
    )

    const GetOffCycleHeadersAndCodes = async (DataSource) => {
        const Response = await FetchAllOffCycleCodesAndHeaders();
        if (Response.statusCode === 200) {
            let TempDefaultHeaders = JSON.parse(Response.payload).DefaultHeaders;
            let TempEAD_Codes = JSON.parse(Response.payload).EAD_Codes;
            setDefaultHeaders(TempDefaultHeaders);
            setEAD_Codes(TempEAD_Codes);

            let TotalHeaders = [];
            DataSource.forEach(eachRecord => {
                Object.keys(eachRecord).map(key => TotalHeaders.push(key));
            });
            TotalHeaders = [...new Set(TotalHeaders)];

            let SelectDefaultHeaders = [];
            TotalHeaders.forEach(eachHeader => {
                if (TempEAD_Codes.includes(eachHeader)) {
                    SelectDefaultHeaders.push(eachHeader);
                };
            });
            setSelectedHeaders(await BuildSelectedHeaders(SelectDefaultHeaders));
        }
    }

    const GetOffCycleData = async (isLoadingRequired) => {
        isLoadingRequired?setSkeletonFlag(true):null;
        const Response = await FetchAllOffCycleData();
        if (Response.statusCode === 200) {
            setGridDataSource(JSON.parse(Response.payload));
            GetOffCycleHeadersAndCodes(JSON.parse(Response.payload));
        }
        setEditingKey("");
        setNewRecordKey("");
        setTimeout(() => {
            setSkeletonFlag(false);
        }, (500));
    }

    const handleGetHistoricData = async () => {
        const Response = await FetchHistoricOffCycleData(PayDate, ProcessedDate);
        if (Response.statusCode === 200) {
            setGridDataSource(JSON.parse(Response.payload));
            GetOffCycleHeadersAndCodes(JSON.parse(Response.payload));
        }
        setEditingKey("");
        setNewRecordKey("");
    }

    const handleDelete = async (record) => {
        const Response = await DeleteOffCycleData(record.OffCycleId);
        if (Response.statusCode === 200) {
            SuccessMessage(Response.message);
            GetOffCycleData(true);
            form.resetFields();
        }
        else {
            ErrorMessage(Response.message);
        }
    }

    const handleSave = async (record) => {
        let ModifiedData = form.getFieldsValue();
        Object.entries(ModifiedData).map(item => { record[item[0]] = item[1]; return item });
        if(StringValidations(record?.File_Number)){
            const Response = await UpdateOffCycleData(record);
            if (Response.statusCode === 200) {
                SuccessMessage(Response.message);
                setEditingKey("");
                GetOffCycleData(true);
                form.resetFields();
            }
            else {
                ErrorMessage(Response.message);
            }
        }
        else{
            WarnMessage("Please add file number!!!");
        }
    }

    const handleCancel = async () => {
        setEditingKey("");
        setNewRecordKey("");
        setGridDataSource([...oldData]);
        form.resetFields();
        GetOffCycleData(false);
    }

    const handleEdit = async (record) => {
        setEditingKey(record.OffCycleId);
        form.setFieldsValue({ ...record });
        setOldData([...GridDataSource]);
    }

    const handleSaveNewRecord = async () => {
        let NewRecord = form.getFieldsValue();
        if (StringValidations(NewRecord?.File_Number)) {
            NewRecord.OffCycleId = parseInt("0");
            const Response = await AddOffCycleData(NewRecord);
            if (Response.statusCode === 200) {
                SuccessMessage(Response.message);
                setEditingKey("");
                setNewRecordKey("");
                GetOffCycleData(true);
            }
            else {
                ErrorMessage(Response.message);
                setEditingKey("");
                setNewRecordKey("");
                GetOffCycleData(true);
            }
        }
        else {
            WarnMessage("Please add file number!!!")
        }
    }

    const handleAddNewOffCycle = async () => {
        if (StringValidations(AddRecordSearch)) {
            const Response = await FetchFileNumberData(AddRecordSearch);
            if (Response.statusCode === 200) {
                let SearchedData = JSON.parse(Response.payload);
                if (editingKey === "") {
                    let NewRecordArray = {};
                    for (let index in columns) {
                        NewRecordArray[columns[index].dataIndex] = "";
                    }

                    NewRecordArray["Co_Code"] = SearchedData?.["Co Code"] ?? "";
                    NewRecordArray["Client"] = SearchedData?.["Home Department"] ?? "";
                    NewRecordArray["Employee_Name"] = `${SearchedData?.["First Name"] ?? ""} ${SearchedData?.["Last Name and Suffix"] ?? ""}`.trim();
                    NewRecordArray["File_Number"] = SearchedData?.["File #"] ?? "";
                    NewRecordArray["Frequency"] = SearchedData?.["Pay Frequency Code"] ?? "";
                    NewRecordArray["State"] = SearchedData?.["State "] ?? "";
                    NewRecordArray["Pay_Rate"] = SearchedData?.["Rate 1 Amount"] ?? "";
                    NewRecordArray["Term_Date"] = SearchedData?.["Termination Date"] ?? "";
                    NewRecordArray["Processed_Date"] = ProcessedDate;
                    NewRecordArray["Pay_Date"] = PayDate;
                    NewRecordArray.OffCycleId = "0";
                    setOldData([...GridDataSource]);
                    setGridDataSource([NewRecordArray, ...GridDataSource]);
                    form.setFieldsValue({ ...NewRecordArray });
                    setNewRecordKey("0");
                    setEditingKey("0");
                }
                else {
                    InfoMessage("Please save/discard the new record...")
                }
            }

            else {
                WarnMessage(`Could not find ${AddRecordSearch}`)
                if (editingKey === "") {
                    let NewRecordArray = {};
                    for (let index in columns) {
                        NewRecordArray[columns[index].dataIndex] = "";
                    }
                    NewRecordArray["Processed_Date"] = ProcessedDate;
                    NewRecordArray["Pay_Date"] = PayDate;
                    NewRecordArray.OffCycleId = "0";
                    setOldData([...GridDataSource]);
                    setGridDataSource([NewRecordArray, ...GridDataSource]);
                    form.setFieldsValue({ ...NewRecordArray });
                    setNewRecordKey("0");
                    setEditingKey("0");
                }
            }
        }
        else {
            WarnMessage("Please enter file number!!!")
        }

    }

    //Handling on uploading Off Cycle Excel
    const handleOffCycleExcelUpload = async (options) => {
        setOffCycleUploadFlag(true);
        const { file } = options;
        setFileList([{ file, status: "uploading" }]);
        const formData = new FormData();
        formData.append("file", file);
        try {
            const Response = await UploadOffCycleData(formData, UserName);
            if (Response.statusCode === 200) {
                SuccessMessage(Response.message);
                setFileList([{ file, status: "done" }]);
                setOffCycleUploadFlag(false);
                GetOffCycleData(true);
            }
            else {
                ErrorMessage(Response.message);
                setFileList([{ file, status: "error" }]);
                setOffCycleUploadFlag(false);
            }
        }
        catch {
            setFileList([{ file, status: "error" }]);
            setOffCycleUploadFlag(false);
            ErrorMessage("Unable to resolve request");
        }
    }

    // Handling Download .CSV Action
    const handleCSVDownload = () => {

        //Gathering all headers from DataSource from different records
        let TotalHeaders = [];
        GridDataSource.forEach(eachRecord => {
            Object.keys(eachRecord).map(key => TotalHeaders.push(key));
        });
        TotalHeaders = [...new Set(TotalHeaders)];

        //Removing unnecessary headers for excel
        let indexOffCycleId = TotalHeaders.indexOf("OffCycleId");
        TotalHeaders.splice(indexOffCycleId, 1);
        let indexCreatedBy = TotalHeaders.indexOf("Created_By");
        TotalHeaders.splice(indexCreatedBy, 1);
        let indexCreatedDate = TotalHeaders.indexOf("Created_Date");
        TotalHeaders.splice(indexCreatedDate, 1);

        //Formatting Excel Headers which has special characters
        let ExcelHeaders = [];
        TotalHeaders.forEach(eachHeader => {
            ExcelHeaders.push(ReplaceUnderscoreWithSpace(eachHeader))
        });


        //Excel workbook creation
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet1");

        //Adding Formatted Excel Headers to the workbook
        worksheet.addRow(ExcelHeaders);

        //Adding every record with respective headers match to the workbook
        GridDataSource.forEach(eachRecord => {
            let ExcelArray = [];
            TotalHeaders.forEach(eachHeader => {
                ExcelArray.push(eachRecord[eachHeader]);
            })
            worksheet.addRow(ExcelArray);
        })

        //returning csv file as output
        return workbook.csv.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: "text/csv;charset=utf-8" });
            FileSaver.saveAs(blob, "OffCycle.csv");
        });
    }

    //Filter Feature for Grid Layout
    const filterProps = () => (
        {
            filteredValue: [SearchGridValue],
            onFilter: (value, record) => {
                return (
                    String(record.File_Number).toLowerCase().includes(value.toLowerCase()) ||
                    String(record.Employee_Name).toLowerCase().includes(value.toLowerCase())
                )
            }
        }
    )

    //Sort Feature for Grid Layout
    const sortProps = (item) => {
        if (item === "File_Number" || item === "Category") {
            return (
                {
                    sorter: (a, b) => a[item].localeCompare(b[item]),
                    sortDirections: ['descend', 'ascend'],
                    showSorterTooltip: false,
                }
            )
        }
    }

    // columns Object 
    const columns = [
        ...DefaultHeaders.map((item, index) => ({
            title: ReplaceUnderscoreWithSpace(item),
            dataIndex: item,
            width: 120,
            editable: true,
            ellipsis: true,
            fixed: item === 'File_Number' || item === 'Co_Code' || item === 'Employee_Name' ? 'left' : null,
            ...filterProps(),
            ...sortProps(item)
        })),
        ...SelectedHeaders.map((item, index) => ({
            title: ReplaceUnderscoreWithSpace(item.key),
            dataIndex: item.key,
            width: 150,
            editable: true,
            ...filterProps()
        })),
        {
            title: "Action",
            dataIndex: "action",
            key: "edit",
            fixed: "right",
            editable: false,
            width: 100,
            render: (_, record) => {
                // console.log(record)
                const editable = isEditing(record);
                return (
                    editable ? (
                        <span>
                            {
                                record.OffCycleId === NewRecordKey ?
                                    <PlusOutlined onClick={handleSaveNewRecord} />
                                    :
                                    <Popconfirm
                                        title="Sure to Save?"
                                        placement="topRight"
                                        onConfirm={() => handleSave(record)}
                                    >
                                        <a>
                                            <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
                                        </a>
                                    </Popconfirm>
                            }

                            <Typography.Link
                                onClick={() => handleCancel()}
                                style={{
                                    marginRight: 8,
                                }}
                            >
                                <CloseOutlined style={{ color: "red" }} />
                            </Typography.Link>
                        </span>
                    ) : (
                        <div>
                            <Typography.Link
                                disabled={editingKey !== ""}
                                onClick={() => handleEdit(record)}
                            >
                                <EditOutlined />
                            </Typography.Link>
                            <Popconfirm
                                title="Sure to Delete?"
                                placement="topRight"
                                onConfirm={() => handleDelete(record)}
                            >
                                <a>
                                    <DeleteOutlined
                                        style={{ color: "#fa5946", marginLeft: "10px" }}
                                    />
                                </a>
                            </Popconfirm>
                        </div>

                    )
                )
            }
        }
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: "text",
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });


    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };



    // File List rendering
    const itemRender = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (FileList.length > 0) {
            fileExists = true;
        }
        return <>
            <div style={{ color: statusColor, width: "100%", display: "flex", justifyContent: "space-between", backgroundColor: "#f2f8fc", marginTop: "2px", borderRadius: "4px" }}>{fileExists ? FileList[0].file.name : null}<DeleteOutlined onClick={() => setFileList([])} /></div>
        </>;
    };

    const handleDownloadOffCycleTemplate = () => {
        let SelectedHeadersArray = SelectedHeaders.map((data) => data.key);
        let TemplateHeaders = [...DefaultHeaders, ...SelectedHeadersArray];
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');
        worksheet.addRow(TemplateHeaders);
        return workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, 'OffCycleTemplate.xlsx');
        })
    }


    useEffect(() => {
        GetOffCycleData(true);
    }, []);


    return (

        <>
            <div className='offcycle-filter-section'>
                <h1 className="offcycle-title">
                    Off Cycle Payroll
                </h1>
                <div className='flex-row-container'>
                    <div className="date-element">
                        <label className='date-label'>Pay Date : </label>
                        <DatePicker format='MM/DD/YYYY' placeholder="MM/DD/YYYY" onChange={(date, dateString) => setPayDate(dateString)} />
                    </div>
                    <div className="date-element">
                        <label className='date-label'>Processed Date : </label>
                        <DatePicker format='MM/DD/YYYY' placeholder="MM/DD/YYYY" defaultValue={dayjs(GetDefaultDate(), "MM/DD/YYYY")} onChange={(date, dateString) => setProcessedDate(dateString)} />
                    </div>
                    <Button className='csv-download-button' onClick={() => handleGetHistoricData()}>
                        Get Data
                    </Button>
                </div>
            </div>

            <div className='offcycle-grid-section'>
                <div className='offcycle-grid-filters-container flex-row-container'>
                    <div className='flex-row-container offcycle-grid-filters-section1'>
                        <Input className="add-record-button" placeholder="Add New Record" onPressEnter={(e) => handleAddNewOffCycle()}
                            onChange={(e) => setAddRecordSearch(e.target.value)} suffix={<PlusOutlined onClick={handleAddNewOffCycle} />} />

                        <div className="offcyle-template-download">
                            <Tooltip title="Select Required Headers and Click for Template Download">
                                <DownloadOutlined onClick={handleDownloadOffCycleTemplate} />
                            </Tooltip>
                        </div>
                        <div className='offcycle-upload'>
                            <Upload.Dragger
                                accept=".xlsx"
                                customRequest={handleOffCycleExcelUpload}
                                itemRender={itemRender}
                                fileList={FileList}
                                onRemove={() => setFileList([])}
                            >
                                <div className='offcycle-upload-label'>
                                    Off Cycle Upload
                                    <img
                                        src="./Images/UploadIcon.png"
                                        style={{ height: "22px", marginLeft: "5px" }}
                                        alt=""
                                    ></img>
                                    {OffCycleUploadFlag ? (
                                        <Spin
                                            indicator={
                                                <div style={{ alignItems: "center" }}>
                                                    <LoadingOutlined />
                                                </div>
                                            }
                                        ></Spin>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </Upload.Dragger>
                        </div>

                        <Input className="search-element" placeholder="Search File Number/ Employee Name" onChange={(e) => setSearchGridValue(e.target.value)} allowClear suffix={<SearchOutlined />} />
                    </div>
                    <div className="offcycle-grid-filters-section2">
                        <div >
                            <Select className='columns-selection-dropdown' mode="multiple" allowClear
                                placeholder={<span className="column-placeholder" style={{ color: 'rgba(0, 39, 102, 1)' }}>Select Columns</span>}
                                maxTagCount='responsive'
                                onChange={(selectedLabels, selectedObject) => { setSelectedHeaders(selectedObject) }}
                                value={SelectedHeaders}
                            >
                                {
                                    EAD_Codes ? EAD_Codes.map((item, index) => {
                                        return (
                                            <Select.Option key={item} value={item}>
                                                {ReplaceUnderscoreWithSpace(item)}
                                            </Select.Option>
                                        )
                                    })
                                        : null
                                }
                            </Select>
                        </div>
                        <Button className='csv-download-button' onClick={handleCSVDownload}>
                            Download .CSV <DownloadOutlined />
                        </Button>
                    </div>
                </div>
                <div className='offcycle-grid-container'>
                    <Form form={form} component={false}>
                        <Table
                            components={{
                                body: {
                                    cell: EditableCell,
                                }
                            }}
                            loading={SkeletonFlag}
                            columns={mergedColumns}
                            dataSource={GridDataSource}
                            scroll={{ x: "max-content", y: 300 }}
                            pagination={false}
                            className="offcycle-grid"
                            bordered
                        />
                    </Form>
                </div>
            </div>
        </>
    )
}

export default OffCycleGrid;